import { createPinia } from 'ui.vue3.pinia';
import {BitrixVue} from "ui.vue3";
import {createRouter, createWebHistory} from "ui.vue3.router";

import {CourseDetail} from "./components/catalog/course-detail";
import {CatalogCourses} from "./components/catalog/catalog-courses";
import {CategoryCourses} from "./components/catalog/category-courses";
import {CategoryGoCurses} from "./components/catalog/category-go-curses";

export class Courses
{
	#application;
	constructor(rootNode) {
		this.rootNode = document.querySelector(rootNode);
	}

	start() {
		this.getTemplate();
	}

	getTemplate() {
		const routes = [
			{
				path: '/courses/', component: CatalogCourses
			},
			{
				path: '/courses/:category',
				component: CategoryCourses,
			},
			{
				path: '/courses/go/:go',
				component: CategoryGoCurses,
			},
			{
				path: '/courses/:category/:course',
				name: 'coursedetail',
				components: { coursedetail: CourseDetail },
				props: { default: false, coursedetail: true }
			},
		];
		const router = createRouter({
			base: '/courses/',
			history: createWebHistory(),
			routes,
		});
		const pinia = createPinia();
		const context = this;
		this.#application = BitrixVue.createApp({
			beforeCreate()
			{
				this.$bitrix.Application.set(context);
			},
			template: `
				<router-view></router-view>
				<router-view name="coursedetail"></router-view>
			`,
		});

		this.#application.use(router);
		this.#application.use(pinia);
		this.#application.mount(this.rootNode);
	}
}
